import React from 'react';
import { formatTime, formatCost } from '../services/deepseekApi';
import '../styles/AIDrillProgress.css';

const AIDrillProgress = ({ progress, isVisible }) => {
  if (!isVisible || !progress) return null;

  const { status, message, timeElapsed = 0, tokensUsed = 0, costIncurred = 0 } = progress;

  const getStatusIcon = () => {
    switch (status) {
      case 'starting':
        return '🔄';
      case 'processing':
        return '⚙️';
      case 'completed':
        return '✅';
      case 'error':
        return '❌';
      default:
        return '⏳';
    }
  };

  const getStatusColor = () => {
    switch (status) {
      case 'starting':
        return '#ffc107';
      case 'processing':
        return '#17a2b8';
      case 'completed':
        return '#28a745';
      case 'error':
        return '#dc3545';
      default:
        return '#6c757d';
    }
  };

  return (
    <div className="ai-drill-progress">
      <div className="progress-header">
        <span className="status-icon">{getStatusIcon()}</span>
        <span className="status-message" style={{ color: getStatusColor() }}>
          {message}
        </span>
      </div>
      
      <div className="progress-stats">
        <div className="stat-item">
          <span className="stat-label">Time:</span>
          <span className="stat-value">{formatTime(timeElapsed)}</span>
        </div>
        
        <div className="stat-item">
          <span className="stat-label">Tokens Used:</span>
          <span className="stat-value">{tokensUsed.toLocaleString()}</span>
        </div>
        
        <div className="stat-item">
          <span className="stat-label">Cost:</span>
          <span className="stat-value">{formatCost(costIncurred)}</span>
        </div>
      </div>

      {status === 'processing' && (
        <div className="progress-bar">
          <div className="progress-fill"></div>
        </div>
      )}
    </div>
  );
};

export default AIDrillProgress;
